import type { SvgIconProps } from '@mui/material';
import SvgIcon from '@mui/material/SvgIcon';

export default function GripLinesVertIcon(props: SvgIconProps) {
  const { children, ...restProps } = props;

  return (
    <SvgIcon {...restProps}>
      <svg width="14" height="24" viewBox="0 0 14 24" stroke="currentColor">
        <path d="M9.24023 5L9.24023 19" strokeWidth="1.2" strokeLinecap="round" />
        <path d="M4.75977 5L4.75977 19" strokeWidth="1.2" strokeLinecap="round" />
      </svg>
    </SvgIcon>
  );
}
